export default "__VITE_ASSET__936c08ee__"